var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-module"},[_c('div',{staticClass:"paragraph",class:[_vm.alignment]},[_c('MarkdownRenderer',[_vm._v(_vm._s(_vm.$t(_vm.text)))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }